<template>
    <b-btn variant="primary" size="sm" @click="navigateTo()" title="Inicio">
        <i class="fas fa-home"></i>
    </b-btn>
</template>
<script>
export default {
    methods: {
        navigateTo() {
            const defaultScreen = this.currentProfile.default_screen
            if (this.$route.name === defaultScreen) return
            this.$router.push({ name: defaultScreen })
        },
    },
}
</script>
